import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LoadSchool } from './../../../../ng2/store/actions/school-actions';
import { getSchool, getSchoolLoadedStatus } from './../../../../ng2/store/selectors/school-selectors';

@Injectable()
export class SchoolResolver {
  resolveSchool$(schoolId, store): Promise<Observable<any>> {
    const destroy$: Subject<boolean> = new Subject<boolean>();

    return new Promise(resolve => {
      store
        .select(getSchoolLoadedStatus)
        .pipe(takeUntil(destroy$))
        .subscribe(loaded => {
          if (!loaded) store.dispatch(new LoadSchool(schoolId));
          if (loaded) {
            const school$ = store.select(getSchool);
            destroy$.next(true);
            destroy$.unsubscribe();
            resolve(school$);
          }
        });
    });
  }
}
